<template>
  <el-dialog
    :visible.sync="visible"
    :title="title"
    :width="width"
    :top="top"
    :fullscreen="fullscreen"
    :draggable="draggable"
    class="ls-select-common-dialog ls-select-dict-dialog"
    :class="customClass"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :destroy-on-close="true"
    @close="close"
  >
    <div
      v-if="visible"
      class="ls-select-dict-main"
      :style="{
        height: fullscreen ? '100%' : isNaN(height % 1) ? height : height + 'px'
      }"
    >
      <div class="main">
        <div class="left" :class="multiple ? '' : 'long'">
          <div class="header">
            <el-icon size="16">
              <User />
            </el-icon>
            <span>可选字典</span>
          </div>
          <div class=""></div>
          <div class="main">
            <div class="dict-box">
              <div class="header">
                <div class="item">
                  <span class="text">字典编码 :</span>
                  <span>{{ dictData.type ? dictData.type.dictTypeCode : "" }}</span>
                </div>
                <div class="item">
                  <span class="text">字典名称 :</span>
                  <span>{{ dictData.type ? dictData.type.dictTypeName : "" }}</span>
                </div>
              </div>
              <div class="content-box" :class="dictTypeTree ? '' : 'border-none'">
                <DictList
                  v-if="!dictTypeTree"
                  ref="lsDictSelectList"
                  :dict="dictData"
                  :multiple="multiple"
                  :selections="tableData"
                  @single="checkSingle"
                  @row-click="selectCurrent"
                ></DictList>
                <el-scrollbar v-if="dictTypeTree" height="100%">
                  <DictTree
                    ref="lsDictSelectTree"
                    :dict="dictData"
                    :selections="tableData"
                    :multiple="multiple"
                    @single="checkSingle"
                    @node-click="selectCurrent"
                  ></DictTree>
                </el-scrollbar>
              </div>
            </div>
            <div class="detail-box" :class="dictTypeTree ? '' : 'border-none'">
              <div class="header">
                <div class="item">
                  <span>字典选项详情 :</span>
                </div>
              </div>
              <div class="content-box">
                <el-scrollbar height="100%">
                  <div class="form-box">
                    <el-form
                      v-if="currentNode && currentNode.code"
                      :model="currentNode"
                      label-position="top"
                    >
                      <el-form-item label="选项编码 :">
                        <div>{{ currentNode.code }}</div>
                      </el-form-item>
                      <el-form-item label="选项名称 :">
                        <div>{{ currentNode.name }}</div>
                      </el-form-item>
                      <template v-for="(item, index) in currentNode.tags">
                        <el-form-item
                          v-if="item.dictTypeVar"
                          :key="index"
                          :label="item.dictTypeVar + ' :'"
                        >
                          <div>
                            {{ item.dictItemVar ? item.dictItemVar : "--" }}
                          </div>
                        </el-form-item>
                      </template>
                    </el-form>
                  </div>
                </el-scrollbar>
              </div>
            </div>
          </div>
        </div>
        <div v-if="multiple" class="middle">
          <el-button size="small" type="primary" @click="addDict">
            <el-icon size="16">
              <Right />
            </el-icon>
            <span>添加</span>
          </el-button>
          <el-button size="small" type="danger" @click="removeDict">
            <el-icon size="16">
              <Back />
            </el-icon>
            <span>移除</span>
          </el-button>
        </div>
        <div class="right">
          <div class="header">
            <el-icon size="16">
              <CollectionTag />
            </el-icon>
            <span>已选字典</span>
          </div>
          <div class="ls-select-search-box">
            <div class="search-item">
              <el-input v-model="search.dictName" placeholder="请输入字典名称" clearable />
            </div>
          </div>
          <!--已选字典-->
          <div class="table-box">
            <el-table
              ref="checkedDictTable"
              :data="tableData"
              size="default"
              style="width: 100%"
              height="100%"
              class="ls-table"
              border
              stripe
              show-overflow-tooltip
              empty-text="暂无数据"
              :header-cell-class-name="cellClass"
              :row-class-name="setRowClass"
            >
              <el-table-column
                v-if="multiple"
                :show-overflow-tooltip="false"
                type="selection"
                width="50"
                align="center"
                fixed
              />
              <el-table-column label="字典名称" prop="dictItemName"></el-table-column>
              <el-table-column label="操作" width="60" align="center" fixed="right">
                <template v-slot="{ row, $index }">
                  <span class="table-btn-delete" @click="delDict(row, $index)">移除</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div class="footer" :style="{ textAlign: align }">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="submit">确定</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import DictList from "./List/index.vue";
import DictTree from "./Tree/index.vue";
import request from "../../../api/request";
export default {
  name: 'LsSelectDict',
  components: {
    DictList,
    DictTree
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    code: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "字典选择",
    },
    fullscreen: {
      type: Boolean,
      default: false,
    },
    draggable: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "1000px",
    },
    height: {
      type: String,
      default: "700px",
    },
    top: {
      type: String,
      default: "5vh",
    },
    customClass: {
      type: String,
      default: "",
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    align: {
      type: String,
      default: "right",
    },
    dict: [],
  },
  data() {
    return {
      visible: this.show,
      search: {
        dictName: ""
      },
      tableData: [],
      dictData: [],
      dictTypeTree: false,
      currentNode: {
        code: "",
        name: "",
        tags: []
      },
      nodeKey: "dictItemCode"
    }
  },
  watch: {
    show: {
      immediate: true,
      deep: true,
      async handler(newValue) {
        this.visible = newValue;
        this.tableData = [];
        this.currentNode = {
          code: "",
          name: "",
          tags: []
        };
        if (newValue) {
          if (!this.code) {
            return;
          }
          await this.getDictData();
          if (this.dict && this.dict.length) {
            await this.getCheckedDict();
          }
        }
      }
    },
    visible(newValue) {
      if (newValue === false) {
        this.$emit("update:show", newValue);
      }
    },
  },
  methods: {
    /*通过字典类型编码获取字典数据*/
    async getDictData() {
      try {
        // const { success, message, data } = await lsfetch.get(
        //   `/api/base/dict/data/type-codes/${this.code}`,
        //   {}
        // );
        const { success, message, data } = await request({
          url: `/api/base/dict/data/type-codes/${this.code}`,
          method: "get",
        });
        // const { success, message, data } = { success:false, message:"111", data:[]}
        if (!success) {
          return this.$message.error("获取字典数据失败:" + message);
        }
        this.dictData = data;
        this.dictTypeTree = this.dictData.type?.dictTypeTree;
      } catch (e) {
        this.$message.error("获取字典数据失败:" + e.message || e);
      }
    },

    /*获取已选字典列表*/
    async getCheckedDict() {
      try {
        // const { success, message, data } = await lsfetch.post(
        //   `/api/base/dict/data/type-codes/${this.code}/items/by-codes`,
        //   {
        //     uniqueCodes: this.dict
        //   }
        // );
        const { success, message, data } = await request({
          url: `/api/base/dict/data/type-codes/${this.code}/items/by-codes`,
          method: "post",
          data: {
            uniqueCodes: this.dict
          }
        });
        // const { success, message, data } = { success:false, message:"111", data:[]}
        if (!success) {
          return this.$message.error("获取已选字典失败:" + message);
        }
        let temp = [];
        if (data && data.length) {
          temp = data;
        }
        this.tableData = temp;
        this.setNodeChecked();
      } catch (e) {
        this.$message.error("获取已选字典失败:" + e.message || e);
      }
    },
    /*单选时将表头的checkbox隐藏*/
    cellClass(row) {
      if (row.columnIndex === 0 && !this.multiple) {
        return "disabledCheck";
      }
    },

    /*表格/树当前行点击*/
    selectCurrent(data) {
      let tags = [];
      const type = this.dictData.type;
      for (let i = 1; i < 5; i++) {
        tags.push({
          dictTypeVar: type["dictTypeVar" + i],
          dictItemVar: data["dictItemVar" + i]
        });
      }
      this.currentNode = {
        code: data.dictItemCode,
        name: data.dictItemName,
        tags
      };
    },

    /*表格/树单选*/
    checkSingle() {
      if (this.dictTypeTree) {
        this.tableData = this.$refs.lsDictSelectTree.getCheckedNodes();
      } else {
        this.tableData = this.$refs.lsDictSelectList.getSelections();
      }
    },

    /*表格/树设置选中*/
    setNodeChecked() {
      this.$nextTick(() => {
        if (this.tableData && this.tableData.length) {
          if (this.dictTypeTree) {
            for (let i = 0; i < this.tableData.length; i++) {
              this.$refs.lsDictSelectTree.setChecked(
                this.tableData[i][this.nodeKey],
                true
              );
            }
          } else {
            let temp = [];
            this.tableData.map((item) => {
              temp.push(item[this.nodeKey]);
            });
            this.$refs.lsDictSelectList.toggleRowSelection(temp, this.nodeKey, true);
          }
        }
      });
    },

    /*添加*/
    addDict() {
      let selections = [];
      if (this.dictTypeTree) {
        //树形
        selections = this.$refs.lsDictSelectTree.getCheckedNodes();
      } else {
        selections = this.$refs.lsDictSelectList.getSelections();
      }
      if (selections.length === 0) {
        return this.$message.error("请选择要添加的字典");
      }
      if (this.multiple) {
        selections.map((item) => {
          const data = this.tableData.find(
            (row) => row[this.nodeKey] === item[this.nodeKey]
          );
          if (!data) {
            this.tableData.push(item);
          }
        });
      } else {
        this.tableData = selections;
      }
    },

    /*移除*/
    removeDict() {
      const selections = this.$refs.checkedDictTable.selection;
      if (selections.length === 0) {
        return this.$message.error("请选择要移除的人员");
      }
      if (this.dictTypeTree) {
        //树形
        for (let i = 0; i < selections.length; i++) {
          const index = this.tableData.findIndex(
            (row) => row[this.nodeKey] === selections[i][this.nodeKey]
          );
          if (index >= 0) {
            this.$refs.lsDictSelectTree.setChecked(selections[i][this.nodeKey], false);
            this.tableData.splice(index, 1);
            i--;
          }
        }
      } else {
        for (let i = 0; i < selections.length; i++) {
          const index = this.tableData.findIndex(
            (row) => row[this.nodeKey] === selections[i][this.nodeKey]
          );
          if (index >= 0) {
            this.$refs.lsDictSelectList.toggleRowSelection(
              [selections[i][this.nodeKey]],
              this.nodeKey,
              false
            );
            this.tableData.splice(index, 1);
            i--;
          }
        }
      }
    },

    /*已选人员表格移除人员*/
    delDict(row, index) {
      this.tableData.splice(index, 1);
      if (this.dictTypeTree) {
        //树形
        this.$refs.lsDictSelectTree.setChecked(row[this.nodeKey], false);
      } else {
        this.$refs.lsDictSelectList.toggleRowSelection(
          [row[this.nodeKey]],
          this.nodeKey,
          false
        );
      }
    },

    /*已选字典表格筛选*/
    setRowClass({ row }) {
      const dictName = this.search.dictName;
      if (dictName) {
        if (row["dictItemName"].indexOf(dictName) > -1) {
          return "row-show";
        } else {
          return "row-hide";
        }
      } else {
        return "row-show";
      }
    },

    /*关闭弹窗/取消*/
    close() {
      if (this.visible) {
        this.visible = false;
        this.$emit("close");
      }
    },

    /*确定*/
    submit() {
      if (this.visible) {
        if (this.tableData.length) {
          this.visible = false;
          this.$emit("submit", this.tableData);
        } else {
          this.$message.error("请选择人员");
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ls-select-dict-dialog {
  display: flex;
  flex-direction: column;

  .ls-select-dict-main {
    width: 100%;

    > .main {
      width: 100%;
      height: calc(100% - 50px);

      &:after {
        display: block;
        width: 0;
        height: 0;
        content: "";
        overflow: hidden;
        clear: both;
      }

      > .left,
      > .right {
        height: 100%;
        border-radius: 4px;
        border-top: 1px solid #ebeef5;
        border-bottom: 1px solid #ebeef5;

        > .header {
          display: flex;
          padding: 10px;
          align-items: center;
          background-color: #f5f7fa;
          border-left: 1px solid #ebeef5;
          border-right: 1px solid #ebeef5;

          > span {
            position: relative;
            top: -1px;
            margin-left: 5px;
          }
        }
      }

      > .left {
        float: left;
        width: calc((100% - 95px) * 0.5);
        box-sizing: border-box;

        &.long {
          width: 50%;
        }

        > .main {
          width: 100%;
          height: calc(100% - 40px);

          > .dict-box,
          > .detail-box {
            width: 100%;
            height: 50%;
            box-sizing: border-box;

            > .header {
              display: flex;
              justify-content: space-between;
              padding: 15px;
              border-left: 1px solid #ebeef5;
              border-right: 1px solid #ebeef5;

              > .item {
                > .text {
                  padding-right: 5px;
                }
              }
            }

            > .content-box {
              width: 100%;
              height: calc(100% - 50px);
              border-top: 1px solid #ebeef5;
              border-left: 1px solid #ebeef5;
              border-right: 1px solid #ebeef5;
              box-sizing: border-box;

              &.border-none {
                border-top: none;
                border-left: none;
                border-right: none;
                height: calc(100% - 49px);
              }

              ::v-deep(.form-box) {
                .el-form-item {
                  margin-bottom: 0;

                  .el-form-item__label {
                    padding: 5px 15px 5px;
                    margin-bottom: 0;
                    background-color: #e8f0f6;
                    font-weight: bold;
                    color: #fff;
                  }

                  .el-form-item__content {
                    padding: 0 15px;
                  }
                }
              }
            }
          }

          > .detail-box {
            border-top: 1px solid #ebeef5;

            &.border-none {
              border-top: none;
            }
          }
        }
      }

      > .right {
        width: calc((100% - 95px) * 0.5);
        border-bottom: none;
        box-sizing: border-box;
        float: right;

        > .ls-select-search-box {
          border-left: 1px solid #ebeef5;
          border-right: 1px solid #ebeef5;
        }

        > .table-box {
          width: 100%;
          height: calc(100% - 101px);

          .table-btn-delete {
            color: var(--szgc-element-danger-color);
            cursor: pointer;

            &:hover {
              color: var(--szgc-element-danger-color-light);
            }
          }

          .ls-table {
            ::v-deep(.disabledCheck) {
              .cell {
                .el-checkbox {
                  display: none;
                }
              }
            }
          }

          ::v-deep(.el-table) {
            .row-show {
              display: table-row;
            }

            .row-hide {
              display: none;
            }
          }
        }
      }

      > .middle {
        float: left;
        display: flex;
        height: 100%;
        width: 70px;
        padding: 0 12px;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        > .el-button {
          margin: 8px 0;
        }
      }
    }

    > .footer {
      padding-top: 16px;
      text-align: center;
    }
  }
}
</style>
